import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/context/AuthContext";
import { useTranslation } from "../../../i18n";

const buttonBase =
  "inline-flex items-center justify-center font-semibold rounded-lg px-5 py-2.5 text-[13.5px] transition-colors duration-150";

const NotFoundPage = () => {
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();
  const tf = (key, fallback) => (t(key) === key ? fallback : t(key));

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-surface-nav text-on-surface font-sans antialiased"
      style={{
        backgroundImage:
          "radial-gradient(700px 400px at 50% 0%, rgb(var(--primary) / 0.07), transparent 60%)",
      }}
    >
      {/* Schachbrett-Kachel + 404 in Mono (Design 8d) */}
      <div className="flex items-center gap-2.5">
        <div className="w-16 h-16 rounded-[10px] checkerboard border border-dashed border-outline grid place-items-center font-mono text-xl font-extrabold text-on-surface-faint">
          ?
        </div>
        <div className="font-mono text-[56px] leading-none font-semibold tracking-[-.02em] text-primary">
          404
        </div>
      </div>

      <h1 className="text-[22px] leading-[1.3] font-semibold mt-6">
        {tf("marketing.notFound.title", "Diese Station gibt es nicht auf dem Band.")}
      </h1>
      <p className="text-[13.5px] leading-relaxed text-on-surface-muted mt-2 max-w-md">
        {tf(
          "marketing.notFound.description",
          "Die Seite wurde verschoben, gelöscht — oder war nie in der Stückliste.",
        )}
      </p>

      <div className="flex flex-wrap justify-center gap-3 mt-7">
        <Link
          to={isAuthenticated ? "/dashboard" : "/"}
          className={`${buttonBase} bg-primary text-on-primary hover:bg-primary-fixed`}
        >
          {isAuthenticated
            ? tf("marketing.notFound.ctaDashboard", "Zum Dashboard")
            : tf("marketing.notFound.ctaHome", "Zur Startseite")}
        </Link>
        <Link
          to="/documentation"
          className={`${buttonBase} border border-outline text-on-surface hover:bg-on-surface/[.06]`}
        >
          {tf("marketing.notFound.ctaHelp", "Hilfe-Center")}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
